import i18next from 'i18next';
import { SmsSubscription } from 'infrastructure/enums';

export interface ISmsSubscriptionItem {
  id: SmsSubscription | null;
  name: string;
}

export const smsSubscriptionDataSource = (): ISmsSubscriptionItem[] => {
  const dataSource: ISmsSubscriptionItem[] = [
    {
      id: SmsSubscription.ManualEnabled,
      name: i18next.t('smsSubscription.manuallyEnabled'),
    },
    {
      id: SmsSubscription.ManualDisabled,
      name: i18next.t('smsSubscription.manuallyDisabled'),
    },
    {
      id: SmsSubscription.TwilioEnabled,
      name: i18next.t('smsSubscription.twilioEnabled'),
    },
    {
      id: SmsSubscription.TwilioDisabled,
      name: i18next.t('smsSubscription.twilioDisabled'),
    },
  ];

  return dataSource;
};
